import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";

const AboutMeMobileCard = (props) => {
  const [content, setContent] = useState(props.content);
  const [icon, setIcon] = useState(props.icon);
  const [shift, setShift] = useState(props.shift);

  useEffect(() => {
    setContent(props.content);
    setIcon(props.icon);
    setShift(props.shift);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        padding: "30px",
        borderRadius: "15px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "30px",
        boxShadow: "8px 5px 15px #E0E0E0",
        border: "1px solid #E0E0E0",
      }}
    >
      {shift ? (
        <>
          <Typography
            style={{ textAlign: "center", fontFamily: "Tenorite" }}
            variant="h5"
            color="text.primary"
          >
            {content}
          </Typography>
          {icon}
        </>
      ) : (
        <>
          {icon}
          <Typography
            style={{ textAlign: "center", fontFamily: "Tenorite" }}
            variant="h5"
            color="text.primary"
          >
            {content}
          </Typography>
        </>
      )}
    </div>
  );
};

export default AboutMeMobileCard;
